// "14/35" under a text input: red from `warnAt` on (a warning), bold once over `max`. It never blocks typing;
// the form's submit check and the server do the rejecting.
export default function CharCounter({ length, max, warnAt, testId }) {
  const over = length > max;
  const cls = over ? "text-red-600 font-semibold" : length >= warnAt ? "text-red-600" : "text-slate-500";
  return (
    <p className={`text-xs text-right ${cls}`} data-testid={testId} aria-live="polite">
      {length}/{max}
    </p>
  );
}
